<template>
    <a
        v-if="!userIsEnrolled && canEnroll && enrollUrl"
        :href="enrollUrl"
        class="button button__pink inline-flex items-center justify-center text-center w-full xl:w-auto space-x-2 2xl:space-x-3 px-2 py-3"
        target="_blank"
        rel="noopener"
    >
        <fa-icon :icon="['fas', 'play-circle']"/>
        <span>Subscribe to Courses</span>
    </a>
    <span
        v-else-if="userIsEnrolled"
        class="button button__grey inline-flex items-center justify-center text-center w-full xl:w-auto space-x-2 2xl:space-x-3 px-2 py-3"
    >
        Already Enrolled
    </span>
</template>
<script>
    import InteractsWithMicrocourseModal from '../../../mixins/InteractsWithMicrocourseModal'

    export default {
        name: 'MicrocourseConfirmationButton',

        mixins: [
            InteractsWithMicrocourseModal
        ],

        props: {
            item: {
                type: Object,
                required: true
            }
        },

        computed: {
            canEnroll () {
                return (this.item?.is_moodle !== false && this.item?.moodle_id !== null) || (this.item?.is_cipd !== false);
            },

            userCoursesEnrolled () {
                return window?.modulesEnrolled || []
            },

            userIsEnrolled () {
                return this.userCoursesEnrolled.includes(this.item?.id)
            },

            enrollUrl () {
                return 'https://share.hsforms.com/1gt4dqqjwTBWzSQefYdsVKw4avp6';
            }
        }
    }
</script>
